import {
  BY_THE_PALLET,
  BY_THE_PALLET_WAREHOUSE_BUILT,
  BY_THE_UNIT_ITEM,
  SQUARE_FOOT_ITEM,
  CUBIC_FOOT_ITEM,
  HUNDREDWEIGHT,
} from "../components/project/settings/utils/billingTypes";
import { getBillingTypesArray } from "./billingHelpers";

const BILLING_TYPE_FIELD_MAP = {
  [BY_THE_PALLET]: ["pallet_type"],
  [BY_THE_PALLET_WAREHOUSE_BUILT]: ["pallet_type"],
  [BY_THE_UNIT_ITEM]: ["unit_type"],
  [SQUARE_FOOT_ITEM]: ["dimensions", "square_footage", "square_footage_type"],
  [CUBIC_FOOT_ITEM]: ["dimensions", "cubic_footage"],
  [HUNDREDWEIGHT]: ["weight"],
};

export function getRequiredFieldsForBillingType(billingType) {
  return BILLING_TYPE_FIELD_MAP[billingType] || [];
}

export function getRequiredBillingFields(billingTypes) {
  if (!Array.isArray(billingTypes) || billingTypes.length === 0) {
    return [];
  }

  const allFields = billingTypes.flatMap(type => getRequiredFieldsForBillingType(type));
  return [...new Set(allFields)];
}

export function getMissingBillingFields(project, shipment) {
  if (!shipment || !shipment.billingType) {
    return [];
  }

  // Get required fields from shipment billing type
  const shipmentRequiredFields = getRequiredFieldsForBillingType(shipment.billingType);

  // Get required fields from project storage billing types
  const storageBillingTypes = getBillingTypesArray(project?.billingTypes?.storage);
  const storageRequiredFields = storageBillingTypes.flatMap(type => getRequiredFieldsForBillingType(type));

  // Combine and dedupe all required fields
  const allRequiredFields = [...new Set([...shipmentRequiredFields, ...storageRequiredFields])];

  if (allRequiredFields.length === 0) {
    return [];
  }

  const receivingSettings = project?.receivingSettings || {};

  const missingFields = allRequiredFields.filter(field => !receivingSettings[field]);

  return missingFields;
}

export function shouldShowBillingFields(project, shipment) {
  const missingFields = getMissingBillingFields(project, shipment);
  return missingFields.length > 0;
}
